<template>
    <v-container class="overflow-y-auto grey lighten-5 sorteio-container" fluid>
        <v-row dense style="width: 100%;">
            <!--COLUNA 1 -->
            <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-tooltip top nudge-bottom="30" align="center">
                            <template v-slot:activator="{ on, attrs }">
                                <v-card v-bind="attrs" v-on="on" class="pa-2 rounded-xl" outlined style="background: linear-gradient(to right, white 0%,white 25%,#F57E27 10%,#F57E27 50%);">
                                    <!--CARD DIA SORTEIO -->
                                    <v-row dense  align="center" justify="center">
                                        <v-col cols="3" style="color: #F57E27;text-align:center;" class="justify-center"  align="center" justify="center" >
                                            <v-flex align="center" justify="center" style="padding-top:10%;">
                                                <v-flex style="line-height:12px;">
                                                    <strong style="font-size:40px;">{{ cardSorteio.dia }}</strong><br />
                                                    <span style="font-size:11px;text-decoration:underline;">{{ cardSorteio.mes }}</span>
                                                </v-flex>                              
                                            </v-flex>                             
                                        </v-col>
                                        <v-col cols="9" style="color: white;text-align:center;" class="justify-center" >
                                            <v-flex align="center" justify="center">Próximo sorteio em <strong>{{ cardSorteio.diasRestantes }} DIAS</strong></v-flex>
                                        </v-col>                            
                                    </v-row>
                                </v-card>                                  
                            </template>
                            <span>
                                Confira no Regulamento período de apuração de cada sorteio.
                            </span>
                        </v-tooltip>                                                
                    </v-col> 
                </v-row>
                <!--VIDEO -->
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-card class="pa-2 rounded-xl" outlined>
                            <iframe width="100%" height="225" src="https://www.youtube.com/embed/Z52WiN1Sz5I" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </v-card>
                    </v-col>
                </v-row>

                <!--HISTÓRICO SORTEIO -->
                <v-row dense style="width: 100%;">
                    <v-col cols="12" align="center" justify="center">
                        <v-card class="pa-2 rounded-lg card-hover" style="border: 1px solid #F57E27; cursor:pointer; color:#F57E27;" @click="historicoSorteioDialog" outlined>
                            <v-row dense style="width:100%">
                                <v-col cols="3"></v-col>
                                <v-col cols="6" align="center" justify="center">
                                    <v-flex style="margin-top:2%;" class="inner-hover">Histórico de sorteio</v-flex>
                                </v-col>
                                <v-col cols="3" align="center" justify="center">
                                    <v-icon color="#F57E27">mdi-arrow-right</v-icon>
                                </v-col>  
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>                
                <!--LEMBRETES -->
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-card class="pa-2 rounded-xl" outlined>
                            <v-card-title style="color:#F57E27;font-size:15px; text-align:justify;line-height: 15px;word-break: break-word !important;">
                                INFORMAÇÕES SOBRE A CAMPANHA
                                <div class="line" style="border-bottom: 1px solid #F57E27;"></div> <br />
                            </v-card-title>
                            <v-card-text>
                                <v-row v-for="(item, i) in lembretes" :key="i">
                                    <v-col cols="2">
                                        <v-icon v-text="item.icone" color="#F57E27"> </v-icon>
                                    </v-col>
                                    <v-col cols="10" style="text-align:justify;">
                                        <v-flex class="box-with-link" v-html="item.texto"></v-flex>
                                    </v-col>                                    
                                </v-row>                                
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>                
            </v-col>
            <!--COLUNA 2 -->
            <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                <!-- SORTEIO -->
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-tooltip top nudge-bottom="30" align="center">
                            <template v-slot:activator="{ on, attrs }">
                                <v-card v-bind="attrs" v-on="on" class="pa-2 rounded-xl" style="background: #1FA9E1;" outlined>
                                    <v-card-title style="word-break: break-word !important;color:white;font-size:15px; text-align:justify;line-height: 15px;padding-left: 5px;padding-right: 5px;padding-bottom: 0px;">
                                        PARTICIPE DO SORTEIO
                                        <div class="line" style="border-bottom: 1px solid white;"></div> <br />
                                    </v-card-title>
                                    <v-card-text style="color:white;font-size:13px; text-align:justify;line-height: 15px;padding-left: 5px;padding-right: 5px;">
                                        <v-row>
                                            <v-col cols="12">                                        
                                                <!-- Atinja <strong>R$ {{ $parent.formatPrice(sorteioInfo.objetivoVenda) }} em vendas</strong> novas para participar.<br /><br /> -->
                                                Atinja <strong>R$ 3.000 em faturamento</strong> de vendas novas para participar.<br /><br />
                                                <v-progress-linear :value="sorteioInfo.progressoPorcentagem" color="progress-bar-gradient" background-color="white" height="23" class="rounded-xl" rounded>
                                                    <template v-slot:default="{ value }">
                                                        <strong style="color:#777;">{{ Math.ceil(value) }}% do requisito mínimo</strong>
                                                    </template>
                                                </v-progress-linear>                                        
                                            </v-col>
                                        </v-row>    
                                        <v-row align="center" justify="center">
                                            <v-col cols="6">
                                                Total em vendas <br />
                                                <span class="sorteio-valor-info">R$ <strong>{{ $parent.formatPrice(sorteioInfo.progressoValor, 2) }}</strong></span>
                                            </v-col>
                                            <v-col cols="6">
                                                Faltam para participar <br />
                                                <span class="sorteio-valor-info">R$ <strong>{{ $parent.formatPrice(sorteioInfo.objetivoVenda > 0 ? sorteioInfo.objetivoVenda - sorteioInfo.progressoValor : sorteioInfo.objetivoVenda, 2) }}</strong></span>                                        
                                            </v-col>
                                        </v-row>                            
                                    </v-card-text>                            
                                </v-card>                                
                            </template>
                            <span class="update-text">{{ atualizacaoTexto }}</span>
                        </v-tooltip> 
                    </v-col>
                </v-row>
                <!-- CUPONS -->
                <v-row dense style="width:100%;">
                    <v-col cols="12">
                        <v-tooltip top nudge-bottom="30">
                            <template v-slot:activator="{ on, attrs }">
                                <v-card v-bind="attrs" v-on="on" class="pa-2 rounded-xl" style="color: #7F838C;">
                                    <v-overlay v-if="sorteioInfo.cuponsGanhos.length < 6" :absolute="true" :value="sorteioInfo.cuponsGanhos.length < 6" color="#AEAEAE" opacity="0.9" style="color:#2C3E50; text-align:center;">
                                        <v-icon size="40" color="#2C3E50">mdi-lock-outline</v-icon><br />
                                        Cupons liberados a partir de <br />
                                        <strong>R$ {{ $parent.formatPrice(sorteioInfo.objetivoVenda, 2) }}</strong> em vendas  
                                    </v-overlay>                            
                                    <v-row>
                                        <v-col cols="8">
                                            Receba mais um número da sorte vendendo: <br />
                                            <span class="sorteio-valor-info">R$ <strong>{{ $parent.formatPrice(sorteioInfo.numeroSorteValor, 2) }}</strong></span>
                                        </v-col>
                                        <v-col cols="4" style="text-align:right;">
                                            Cupons ganhos <br /><br />
                                            <span class="sorteio-valor-info" ><strong>{{ sorteioInfo.cuponsGanhos.length }}</strong></span>
                                        </v-col>    
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="numero-sorte-info">
                                            *A cada R$ 500,00  em vendas novas, você ganha um novo número da sorte
                                        </v-col>
                                        <!-- <v-col cols="4">
                                            <v-btn color="#1FA9E1" @click="listarCupons" style="text-decoration:underline;" text>
                                                Ver meus <br />cupons
                                            </v-btn>                                             
                                        </v-col>                                         -->
                                    </v-row>
                                </v-card> 
                            </template>
                            <span>
                                Complete os requisitos para liberar os cupons da sorte.
                            </span>                                    
                        </v-tooltip>                       
                    </v-col>
                </v-row>
                <!-- PRÊMIOS -->
                <v-row dense style="width:100%;">
                    <v-col cols="12">
                        <v-card  class="pa-2 rounded-xl">
                            <br />
                            A cada sorteio, serão sorteados <strong>8 prêmios!</strong>
                            <br /><br />
                            <v-carousel v-model="premioCarousel" :hide-delimiter-background="true" :show-arrows-on-hover="sorteioPremio.length < 3" :show-arrows="sorteioPremio.length > 2" :hide-delimiters="true" delimiter-icon="mdi-circle" prev-icon="mdi-arrow-left" next-icon="mdi-arrow-right" style="height:150px">
                                <v-carousel-item v-for="index in Math.ceil(sorteioPremio.length/2)" :key="index" > 
                                    <v-sheet color="white">
                                        <v-row align="center" justify="center">
                                            <v-col cols="6" v-for="(item, i) in sorteioPremio.slice((2*index-2), 2*index)" :key="i" align="center" justify="center">
                                                <v-card class="rounded-xl" color="white" style="text-align: center;">
                                                    <v-tooltip top nudge-bottom="30" align="center">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-flex v-bind="attrs" v-on="on"  align="center" justify="center">
                                                                <v-badge left color="#F57E27" :content="item.total" offset-x="10" offset-y="20">
                                                                    <img style="padding:0px;" :src="`data:image/png;base64,${item.image}`" height="86" width="100" />
                                                                    <br />
                                                                    <strong style='text-decoration:underline;font-size:11px;color:#7F838C;'>{{ item.nome }}</strong> 
                                                                    <br /><br />                                                                     
                                                                </v-badge>
                                                            </v-flex>
                                                        </template>
                                                        <span>
                                                            {{ item.descricao }}
                                                        </span>                                                          
                                                    </v-tooltip>
                                                </v-card>
                                            </v-col>                                        
                                        </v-row>                                     
                                    </v-sheet>                                                               
                                </v-carousel-item>
                            </v-carousel>   
                            <v-flex style="font-style:italic;">Imagens meramente ilustrativas. Consulte regulamento</v-flex>                         
                        </v-card>                        
                    </v-col>
                </v-row>                
            </v-col>
            <!--COLUNA 3  style="background: #64CF5C;" -->
            <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-card class="pa-2 rounded-xl" outlined :style="corretorCampanha.cardEstilo">
                            <v-row dense style="width: 100%;">
                                <v-col cols="12"></v-col>
                            </v-row>                                
                            <v-row dense style="width: 100%;">
                                <v-col cols="8">
                                    <v-badge bottom color="white" offset-x="20" offset-y="20">
                                        <template v-slot:badge>
                                            <v-icon color="black" style="cursor:pointer;" @click="uploadDialog()">mdi-camera-plus-outline</v-icon>
                                        </template>
                                        <v-avatar size="57" color="white">
                                            <v-avatar color="#bbb">
                                                <v-icon color="black" v-if="corretorCampanha.avatar == null" dark>mdi-account-circle</v-icon>
                                                <img v-if="corretorCampanha.avatar != null" :src="`data:image/png;base64,${corretorCampanha.avatar.base64}`" />
                                            </v-avatar>                                
                                        </v-avatar>
                                    </v-badge>
                                    <br /><br />
                                    <v-flex style="color:white; font-size: 16px;">{{ this.$parent.corretorNome }}</v-flex>                                          
                                </v-col>
                                <v-col cols="4" style="text-align:center; align-items: center;">
                                    <br />
                                    <!-- <img :src="`/upload/sou_mais/${corretorCampanha.nivel}.png`" style="width:50px;height:50px;" />
                                    <v-flex style="color:white; font-size: 12px;">Nível {{ corretorCampanha.nivelNome }}</v-flex>                                         -->
                                </v-col>
                            </v-row>
                            <v-row dense style="width: 100%;">
                                <v-col cols="12"></v-col>
                            </v-row>          
                            <v-row dense style="width: 100%;">
                                <v-col cols="12"><br /></v-col>
                            </v-row>                                                   
                            <v-row dense style="width: 100%;">
                                <v-col cols="12" style="color:#7F838C;">
                                    <strong>SUAS CONQUISTAS</strong><br />
                                    Cumpra tarefas importantes e obtenha suas conquistas  
                                    <br /><br />                                  
                                </v-col>
                            </v-row>
                            <v-row dense style="width: 100%;">
                                <v-col xs="12" sm="12" md="3" lg="3" xl="3" v-for="(item, i) in conquistas.slice(0,4)" :key="i" style="text-align:center;">
                                    <v-tooltip top nudge-bottom="30" >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-flex v-bind="attrs" v-on="on">
                                                <v-avatar size="62">
                                                    <v-img :class="!item.Conquistado ? `imagem-borrada` : ``"  :src="`data:image/png;base64,${item.Conquista.Icone.base64}`"></v-img>
                                                </v-avatar>
                                                <v-flex v-if="!item.Conquistado" style="color:#A6ACBE; font-size:11px;">{{ item.Conquista.Nome }}</v-flex>
                                                <v-flex v-if="item.Conquistado" style="color:black; font-size:11px;">{{ item.Conquista.Nome }}</v-flex>  
                                            </v-flex>
                                        </template>
                                        <span>
                                            {{ item.Conquistado ? item.Conquista.DesbloqueioTitulo : item.Conquista.Descricao }}
                                        </span>                                           
                                    </v-tooltip>                                                                  
                                </v-col>   
                            </v-row>  
                            <v-row dense style="width: 100%;">
                                <v-col cols="6"></v-col>
                                <v-col cols="6" style="text-align:right;">
                                    <v-spacer></v-spacer>
                                    <v-btn color="#1FA9E1" @click="conquistaInfoDialog()" text style="text-decoration:underline;">Ver todas</v-btn>                                      
                                </v-col>                              
                            </v-row>                                                         
                        </v-card>
                    </v-col>
                </v-row>
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-card style="text-align:center;color:#7F838C;" color="#fafafa" align-self-center flat>
                            <v-card-title style="word-break: break-word !important;">
                                PRECISA DE AJUDA?
                                <div class="line" style="border-bottom: 1px solid #7F838C;"></div> <br />
                            </v-card-title>  
                            <v-card-text>
                                <v-tooltip top nudge-bottom="30"  v-for="(item, i) in ajudaTopicos.slice(0,5)" :key="i">>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-row dense v-bind="attrs" v-on="on">
                                            <v-col cols="1" align="center" justify="center">
                                                <v-icon color="#7F838C" @click="ajudaTopicoDialog(item)" class="hover">mdi-chevron-right-circle-outline</v-icon>
                                            </v-col>
                                            <v-col cols="10" align="left" justify="center">
                                                <v-btn color="#1FA9E1" @click="ajudaTopicoDialog(item)" text>
                                                    <div style="white-space:nowrap;width:250px;overflow-x:hidden;text-overflow:ellipsis;text-decoration:underline;">
                                                        {{ item.questao }}
                                                    </div>
                                                </v-btn> 
                                            </v-col>
                                        </v-row>                                          
                                    </template>
                                    <span>
                                        {{ item.questao }}
                                    </span>                                    
                                </v-tooltip>                                                  
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#1FA9E1" @click="ajudaTudoDialog(false)" text outlined rounded>
                                    Ver todos os tópicos
                                    <v-icon>mdi-arrow-right</v-icon>
                                </v-btn>
                            </v-card-actions>                                                      
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>  
        <!-- OVERLAY DE CONQUISTAS -->
        <v-overlay v-if="notificarConquista != null" :value="true">
            <v-container fluid fill-height style="width:900px; height:800px;background: url('/upload/sou_mais/bg_party.png') center center; background-repeat: no-repeat; background-size: contain;">
                <v-row align="center" justify="center">
                    <v-col cols="12" align-self="center">
                        <v-card max-width="600" max-height="500" style="margin: 0px 20%;" rounded color="white">
                            <v-card-text>
                                <div class="display-3" style="width:100%;text-align: center;">
                                    <v-avatar size="100">
                                        <v-img :src="`data:image/png;base64,${notificarConquista.Conquista.Icone.base64}`"></v-img>
                                    </v-avatar><br />
                                    <strong style='color:#1FA9E1;font-size:50px;'>Sensacional!</strong>
                                    <div style="font-size:18px; line-height:30px; color:black;" v-html="notificarConquista.Conquista.DesbloqueioDescricao"></div>   
                                    <v-btn @click="marcarConquistaNotificada(notificarConquista.Id)" color="primary" width="130" rounded>OK</v-btn>                                                                  
                                </div>                      
                            </v-card-text>
                        </v-card>                        
                    </v-col>
                </v-row>
            </v-container>
        </v-overlay>        
        <v-dialog v-model="dialogDinamico.mostrar" :width="dialogDinamico.width" :style="dialogDinamico.estilo" :persistent="dialogDinamico.persistir" rounded align-self-center>
            <v-card class="rounded-xl" rounded align-self-center>
                <v-card-title style="word-break: break-word !important;">
                    <v-flex v-html="dialogDinamico.titulo"></v-flex>
                </v-card-title>
                <v-card-subtitle>
                    <v-flex v-html="dialogDinamico.subTitulo"></v-flex>
                </v-card-subtitle>
                <v-card-text class="text-center overflow-y-auto">
                    <v-flex v-if="dialogDinamico.campanhaRegra">
                        <v-carousel v-model="campanhaRegraCarousel" :continuous="false" :hide-delimiter-background="true" :show-arrows-on-hover="false" delimiter-icon="mdi-circle" prev-icon="mdi-arrow-left" next-icon="mdi-arrow-right" style="height:400px;">
                            <v-carousel-item v-for="(item, i) in campanhaRegraLista" :key="i">
                                <v-sheet color="white">
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <img style="padding:0px;" :src="`/upload/sou_mais/${item.imagem}`" :max-width="item.imagemWidth" :max-height="item.imagemHeight" /><br />
                                        </v-col>                              
                                    </v-row>    
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <strong style='color:#1FA9E1;font-size:50px;'>{{ item.titulo }}</strong>
                                            <div style="font-size:18px; line-height:30px; color:black;" v-html="item.texto"></div>                                        
                                        </v-col>                                        
                                    </v-row>
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <v-btn v-if="item.acao" @click="regulamentoDialog()" color="#1FA9E1" rounded large outlined><strong style="font-size:18px;">Clique aqui para acessar</strong></v-btn>
                                            <v-btn v-if="item.ultimo" @click="marcarCampanhaRegraLida()" color="#1FA9E1" rounded large outlined><strong style="font-size:18px;">Continuar</strong></v-btn>   
                                        </v-col>                                        
                                    </v-row>                                                                           
                                </v-sheet>                                                               
                            </v-carousel-item>
                        </v-carousel>
                    </v-flex>                    
                    <v-flex v-if="dialogDinamico.conteudoDinamico">
                        <v-flex v-if="dialogDinamico.conteudo != 'PERIODO_SORTEIO'" v-html="dialogDinamico.conteudo"></v-flex>
                        <div v-if="dialogDinamico.conteudo == 'PERIODO_SORTEIO'">
                            <v-row dense style="width:100%;">
                                <v-col cols="6">
                                    <strong>Período apuração</strong>
                                </v-col>
                                <v-col cols="6">
                                    <strong>Data Sorteio</strong>
                                </v-col>
                            </v-row>
                            <v-row dense style="width:100%;" v-for="(item, i) in historicoSorteio" :key="i">
                                <v-col cols="6">
                                    {{ item.PeriodoApuracao }}
                                </v-col>
                                <v-col cols="6">
                                    {{ simplificarData(item.Data) }}
                                </v-col>
                            </v-row>                                    
                        <br />
                        </div>                        
                        
                    </v-flex>
                    <v-flex v-if="dialogDinamico.historicoSorteio">
                        <v-row dense style="width: 100%;">
                            <v-col cols="4"  v-for="(item, i) in historicoSorteio" :key="i">
                                <v-card style="max-height:170px;" class="pa-2" :color="item.CodigoCor" outlined>
                                    <v-card-text style="text-align:left; padding:5px !important;">
                                        <strong class="historico-sorteio-nome">{{ item.Nome }}</strong>
                                        <br />
                                        Período de apuração: {{ item.PeriodoApuracao }}
                                        <br />
                                        Sorteio dia : {{ simplificarData(item.Data) }}  
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="white" @click="listarCupons(item.Competencia)" text>
                                            ver meus números da sorte <v-icon>mdi-chevron-right-circle-outline</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row dense style="width: 100%;">
                            <v-col cols="4"  v-for="(item, i) in historicoSorteio" :key="i">
                                <v-card class="pa-2" outlined>
                                    <v-card-text style="text-align:left;">
                                        <strong>Sorteio dia : {{ simplificarData(item.Data) }} </strong>
                                        <br />
                                        <strong>Números sorteados:</strong>
                                        <v-flex v-for="(numero, j) in item.Numeros" :key="j">
                                            {{ numero }} <br />
                                        </v-flex>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>                        
                    </v-flex>
                    <v-flex v-if="dialogDinamico.conquistaRegra">
                        <v-carousel v-model="conquistaRegraCarousel" :continuous="false" :hide-delimiter-background="true" :show-arrows-on-hover="false" delimiter-icon="mdi-circle" prev-icon="mdi-arrow-left" next-icon="mdi-arrow-right" style="height:390px;">
                            <v-carousel-item v-for="(item, i) in conquistaRegraLista" :key="i">
                                <v-sheet color="white">
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <img style="padding:0px;" :src="`/upload/sou_mais/${item.imagem}`" :max-width="item.imagemWidth" :max-height="item.imagemHeight" /><br />
                                        </v-col>                              
                                    </v-row>    
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <strong style='color:#1FA9E1;font-size:50px;'>{{ item.titulo }}</strong>
                                            <div style="height:100px;font-size:18px; line-height:30px; color:black;" v-if="!item.ultimo" v-html="item.texto"></div>                                        
                                        </v-col>                                        
                                    </v-row>
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <v-btn v-if="item.ultimo" @click="marcarConquistaRegraLida()" color="#1FA9E1" rounded large outlined><strong style="font-size:18px;">Continuar</strong></v-btn>
                                        </v-col>                                        
                                    </v-row>                                                                                                                 
                                </v-sheet>                                                               
                            </v-carousel-item>
                        </v-carousel>
                    </v-flex>

                    <v-flex v-if="dialogDinamico.conquistaInfo">
                        <v-row dense v-for="(item, i) in conquistas" :key="i">
                            <v-col cols="12">
                                <v-card align-self-center>
                                    <div class="d-flex flex-no-wrap">
                                        <v-avatar align-self-center size="80">
                                            <v-img :class="!item.Conquistado ? `imagem-borrada` : ``"  :src="`data:image/png;base64,${item.Conquista.Icone.base64}`"></v-img>
                                        </v-avatar>
                                        <div style="width:100%;">
                                            <v-card-title style="line-height: 0;word-break: break-word !important;" class="justify-start" v-text="item.Conquista.Nome"></v-card-title>
                                            <v-card-text style="text-align:left;" class="justify-start" v-text="item.Conquistado ? item.Conquista.DesbloqueioTitulo : item.Conquista.Descricao"></v-card-text>
                                            <v-card-actions class="justify-end">
                                                <v-spacer></v-spacer>
                                                <v-flex style="text-align:right;" v-text="item.Conquistado ? FormatarData(item.DataInclusao) : 'bloqueada'"></v-flex>
                                            </v-card-actions>
                                        </div>   
                                    </div>
                                </v-card>                                
                            </v-col>
                        </v-row>                     
                    </v-flex>   

                    <v-flex v-if="dialogDinamico.ajudaTudo">
                        <v-row dense v-for="(item, i) in ajudaTopicos" :key="i">
                            <v-col cols="12" style="text-align:justify;">
                                <strong>{{ item.questao }}</strong><br />
                                <div v-if="item.resposta != 'PERIODO_SORTEIO'" v-html="item.resposta"><br /></div>
                                <div v-if="item.resposta == 'PERIODO_SORTEIO'">
                                    <v-row dense style="width:100%;">
                                        <v-col cols="6">
                                            <strong>Período apuração</strong>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>Data Sorteio</strong>
                                        </v-col>
                                    </v-row>
                                    <v-row dense style="width:100%;" v-for="(item, i) in historicoSorteio" :key="i">
                                        <v-col cols="6">
                                            {{ item.PeriodoApuracao }}
                                        </v-col>
                                        <v-col cols="6">
                                            {{ simplificarData(item.Data) }}
                                        </v-col>
                                    </v-row>                                    
                                
                                <br />
                                </div>
                                
                            </v-col>                                    
                        </v-row>  
                    </v-flex>  
                    <v-flex v-if="dialogDinamico.listaCupom">
                        <v-row dense>
                            <v-col cols="12" style="text-align:justify;">
                                <v-simple-table fixed-header height="300px">
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                PERÍODO DE APURAÇÃO
                                            </th>
                                            <th class="text-left">
                                                TOTAL DE NÚMEROS
                                            </th>                                                
                                            <th class="text-left">
                                                NÚMERO DA SORTE
                                            </th>                                                                                 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in sorteioInfo.cuponsGanhos.filter(item => item.Competencia == cupomCompetencia)" :key="i">
                                            <td>{{ item.ValidadeDescricao }}</td>
                                            <td>{{ i+1 }}</td>
                                            <td>{{ item.NumeroCampanha }}</td>                                        
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>                            
                            </v-col>
                        </v-row>
                        <v-row dense v-show="false">
                            <v-col cols="4" style="text-align:justify;" v-for="(item, i) in sorteioInfo.cuponsGanhos" :key="i">
                                <v-card color="#EDEDED" v-if="item.Competencia == cupomCompetencia">
                                    
                                    <v-card-title>
                                        <strong>Código</strong>
                                    </v-card-title>
                                    <v-card-text><span style="font-size: 25px;">{{ item.NumeroCampanha }}</span></v-card-text>
                                    <v-card-actions>*<span style="font-style:italic; font-size: 12px;">{{ item.ValidadeDescricao }}</span> </v-card-actions>


                                </v-card>
                            </v-col>                                    
                        </v-row>   
                        
                                              
                    </v-flex>                                   
                </v-card-text> 
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="dialogDinamico.listaCupom" @click="marcarCupomLido" color="primary" style="min-width:100px;" outlined rounded><strong>OK</strong></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="dialogDinamico.ajudaTudo && dialogDinamico.persistir" @click="verificaCampanhaRegraLida" color="primary"><v-icon>mdi-check</v-icon> Ok</v-btn>
                    <v-btn v-if="dialogDinamico.botaoFechar" @click="dialogDinamico.mostrar = false;" color="primary"><v-icon>mdi-check</v-icon> Ok</v-btn>
                    
                </v-card-actions>                               
            </v-card>
        </v-dialog>
        <my-upload 
            field="img"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="uploadShow"
            :width="300"
            :height="300"
            :params="uploadParams"
            :headers="uploadHeaders"
            img-format="png"
            langType="pt-br"
            :noSquare="true"
        ></my-upload>        
    </v-container>
</template>
<script>
    import Vue from 'vue';
    import Helpers from "@/utilities/Helpers";
    import { mapState, mapGetters } from "vuex";
    import SouMaisPrevisul from '@/assets/jsonStore/SouMaisPrevisul.json';
    import myUpload from 'vue-image-crop-upload'; 

export default {
    mixins: [Helpers],
    components:{ 'my-upload': myUpload },
    data () {
        return {
            cardSorteio: {
                dia: '0',
                mes: '',
                diasRestantes: '0'
            },
            lembretes : SouMaisPrevisul.SorteioCampanha.Lembretes,
            atualizacaoTexto: 'Valores atualizados em 2 horas',
            sorteioInfo : SouMaisPrevisul.SorteioCampanha.SorteioInfo,
            sorteioPremio : SouMaisPrevisul.SorteioCampanha.Premios,
            premioCarousel: 0,
            conquistaRegraCarousel: 0,
            campanhaRegraCarousel: 0,
            dialogDinamico: 
            {
                width: 750,
                estilo: "height:300px;",
                persistir: false,
                mostrar: false,
                titulo: "",
                subTitulo: "",
                conteudo: "",
                conteudoDinamico: false,
                historicoSorteio: false,
                conquistaRegra: false,
                conquistaInfo: false,
                ajudaTudo: false,
                listaCupom: false,  
                campanhaRegra: false, 
                botaoFechar: false             
            },  
            //historicoSorteio:SouMaisPrevisul.SorteioCampanha.HistoricoSorteio,
            historicoSorteio : [],
            corretorCampanha: {
                Id: 0,
                avatar: null,
                nivel: "",
                nivelNome: "",
                cardEstilo : "background: linear-gradient(to top, white 0%,white 5%,#727272 10%,#727272 60%);",
                campanhaRegraLida: false,
                conquistaRegraLida: false,
            },
            conquistas : [],
            conquistaRegraLista: SouMaisPrevisul.ConquistaRegras,
            ajudaTopicos : SouMaisPrevisul.SorteioCampanha.Ajuda,
            uploadShow: false,  
            uploadParams : {
                token: '12345678',
                avatar: 'avatar'
            },
            uploadHeaders : {
                smail : '*_~'
            }, 
            campanhaRegraLista : SouMaisPrevisul.SorteioCampanha.CampanhaRegras,
            notificarConquista: null,  
            cupomCompetencia:0,
            cupomHeaders: [
                {text: "ValidadeDescricao", value: "Período de apuração", sortable: true},
                {text: "Apólice", value: "NumeroApoliceSemPonto", sortable: false, align: ' d-none'},
                {text: "Sub", value: "NumeroSub", sortable: true},
                {text: "Total Módulos", value: "NumeroTotal", sortable: true},
                {text: "Estipulante/Segurado", value: "EstipulanteSegurado", sortable: true},
                {text: "CNPJ/CPF", value: "CnpjCpf", sortable: true},
                {text: "CNPJ/CPF com ponto", value: "CnpjCpfComPonto", sortable: false, align: ' d-none'},
                {text: "Emissão", value: 'DataEmissao', sortable: true},
                {text: "Download", value: "anexo", sortable: false }
            ]                                         
        }
    },
    methods: {
        reiniciarDialog()
        {
            this.dialogDinamico.width = 750;
            this.dialogDinamico.estilo="height:300px;";
            this.dialogDinamico.persistir = false;
            this.dialogDinamico.mostrar=false;
            this.dialogDinamico.titulo="";
            this.dialogDinamico.subTitulo="";
            this.dialogDinamico.conteudo="";
            this.dialogDinamico.conteudoDinamico=false;
            this.dialogDinamico.historicoSorteio=false;

            this.dialogDinamico.conquistaRegra=false;
            this.dialogDinamico.conquistaInfo=false;
            this.dialogDinamico.ajudaTudo=false;
            this.dialogDinamico.listaCupom=false;
            this.dialogDinamico.campanhaRegra=false;
            this.dialogDinamico.botaoFechar=false;
        },
        historicoSorteioDialog()
        {
            this.reiniciarDialog();
            this.dialogDinamico.titulo = "<div class='dialog-titulo'>Histórico de sorteios</div><div class='dialog-sub-titulo'> • Acompanhe os vencedores de cada sorteio</div>";
            this.dialogDinamico.historicoSorteio=true;
            this.dialogDinamico.width = 1100;
            this.dialogDinamico.botaoFechar=true;
            this.dialogDinamico.mostrar=true;
        },
        uploadDialog()
        {  
            this.uploadShow = !this.uploadShow;               
        },
        regulamentoDialog()
        {
            this.$parent.regulamentoAssinado = true;
            this.$parent.campanhaRegulamento = 2;
            this.$parent.dialogRegulamento = true;  
        },           
        carregarDados()
        {
            let codigoCorretor = this.usuario.codCorretor;
            let url = "SouMaisPrevisul/corretor/"+ codigoCorretor;                
            
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.get(url)
            .then(res => {
            this.corretorCampanha.Id = res.data.Id;
            this.corretorCampanha.avatar =  res.data.Avatar != null ? res.data.Avatar : null;
            this.corretorCampanha.nivel = res.data.Nivel;
            this.corretorCampanha.nivelNome = res.data.NivelNome;
            this.corretorCampanha.campanhaRegraLida = res.data.CampanhaRegraLida;
            //this.corretorCampanha.conquistaRegraLida = res.data.ConquistaRegraLida;
            this.corretorCampanha.conquistaRegraLida = true;
            this.conquistas = res.data.Conquistas;

            this.atualizacaoTexto = `Valores atualizados em ${res.data.AtualizacaoMesAno}`;

            this.sorteioInfo = {
                objetivoVenda : res.data.TotalizacaoMeta.valorMetaVendaNova,
                progressoPorcentagem : res.data.TotalizacaoMeta.valorPercentualAtingidoVendaNova,
                progressoValor : res.data.TotalizacaoMeta.valorVendaNovaAtual,
                valorFaltante: res.data.TotalizacaoMeta.valorFaltaMetaVendaNova,
                numeroSorteValor: res.data.ValorProximoCupom,
                cuponsGanhos: res.data.NumeroSorteio
            };

            this.cardSorteio = {
                dia: res.data.ProximoSorteio.Dia,
                mes: res.data.ProximoSorteio.Mes,
                diasRestantes: res.data.ProximoSorteio.PeriodoRestante
            };

            this.historicoSorteio = res.data.Sorteios;

            console.log("carregarDados", res.data);

            this.corretorCampanha.nivel = 'DiamanteAzul';

            //let _percentGradient = "72";
            let _percentGradient = "65";
            if(this.conquistas.length < 5)
                _percentGradient = "65";

            switch (this.corretorCampanha.nivel) {
            case 'Cristal':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#727272 10%,#727272 50%);`;
                break;
            case 'Topazio':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#E6843F 10%,#E6843F 50%);`;
                break;
            case 'Esmeralda':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#64CF5C 10%,#64CF5C 50%);`;
                break;     
            case 'Safira':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#1D3F65 10%,#1D3F65 50%);`;
                break;       
            case 'DiamanteAzul':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#50A7DC 10%,#50A7DC 50%);`;
                break;                                                        
            default:
                console.log(`Sorry, we are out of.`);
            }

            this.verificaCampanhaRegraLida();
            this.$parent.fullLoading = false;
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });                
        },
        conquistaInfoDialog()
        {
            this.reiniciarDialog();
            if(this.corretorCampanha.conquistaRegraLida)
            {
                this.dialogDinamico.conquistaInfo = true;
                this.dialogDinamico.titulo = "<div class='dialog-titulo'>Conquistas</div>"
                this.dialogDinamico.subTitulo = "<div class='dialog-sub-titulo'>Continue vendendo e acompanhe seu progresso com as conquistas desbloqueadas</div>";
                this.dialogDinamico.mostrar = true;
            }
            else
            {
                this.dialogDinamico.persistir = true;
                this.dialogDinamico.conquistaRegra = true;
                this.dialogDinamico.mostrar = true;
            }
        },
        marcarConquistaRegraLida()
        {
            let url = "SouMaisPrevisul/corretor/conquista-regra-lida/"+ this.corretorCampanha.Id;                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.put(url)
            .then(res => {
                this.corretorCampanha.conquistaRegraLida = res.data;
                this.reiniciarDialog();
                this.dialogDinamico.mostrar = false; 
                this.conquistaInfoDialog();
                this.$parent.fullLoading = false;           
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });                   

        },
        ajudaTopicoDialog(topico)
        {
                this.reiniciarDialog();
                this.dialogDinamico.titulo = `<div class='dialog-titulo'>${topico.questao}</div>`;
                this.dialogDinamico.conteudo = topico.resposta;
                this.dialogDinamico.conteudoDinamico = true;
                this.dialogDinamico.botaoFechar = true;
                this.dialogDinamico.mostrar = true;                
        },
        ajudaTudoDialog(persistir)
        {
                this.dialogDinamico.campanhaRegra = false;
                this.dialogDinamico.persistir = persistir;
                
                this.dialogDinamico.titulo = `<div class='dialog-titulo'>Precisa de ajuda?</div>`;
                this.dialogDinamico.subTitulo = `<div class='dialog-sub-titulo'>Entenda como funciona a campanha e seu dashboard</div>`;
                this.dialogDinamico.ajudaTudo = true;
                this.dialogDinamico.botaoFechar = !persistir;
                this.dialogDinamico.mostrar = true;    
        },
        cropSuccess(imgDataUrl, field)
        {
            console.log("imgDataUrl");
            console.log(imgDataUrl);
            
            //data:image/png;base64,

            let _avatar = { Id : this.corretorCampanha.Id, AvatarBase64: imgDataUrl.replace('data:image/png;base64,', '') };

            let url = 'SouMaisPrevisul/corretor/avatar';                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.post(url, _avatar)
            .then(res => {
                console.log(url);    
                console.log(res.data);
                this.uploadShow = false;
                this.$parent.fullLoading = false;
                if (res.data == true)
                    this.carregarDados();                
                else
                {
                    this.showToast("error", "Erro", "Ocorreu um problema no carregamento");   
                }
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });              
        },
        cropUploadSuccess(jsonData, field)
        {
            console.log("cropUploadSuccess");
            console.log(jsonData);
            console.log('field '+ field);
        },
        cropUploadFail(status, field)
        {
            console.log("cropUploadFail");
            console.log(status);
            console.log('field '+ field);                
        },
        marcarCampanhaRegraLida()
        { 
            let url = "SouMaisPrevisul/corretor/campanha-regra-lida/"+ this.corretorCampanha.Id;                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.put(url)
            .then(res => {
            console.log(url);    
            console.log(res.data);
            this.corretorCampanha.campanhaRegraLida = res.data;
            this.reiniciarDialog();
            this.dialogDinamico.mostrar = false; 
            this.$parent.fullLoading = false;
            this.verificarConquistaNotificada();
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });                  
        },
        verificarConquistaNotificada()
        {
            let _corretorId = this.corretorCampanha.Id;
            console.log("verificarConquistaNotificada");
            console.log(this.conquistas);     
            
            let _conquista = this.conquistas.find((item) => item.Conquistado == true && item.Notificado == false);

            console.log("find > conquista");
            console.log(_conquista);
            if(_conquista != undefined)
            {
                this.reiniciarDialog();
                this.notificarConquista = _conquista;
            }           
        }, 
        marcarConquistaNotificada(id)
        {
            let url = "SouMaisPrevisul/corretor/conquista-notificada/"+ id;                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.put(url)
            .then(res => {
            this.notificarConquista = null;
            this.$parent.fullLoading = false;
            this.carregarDados();
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });             
        },
        verificaCampanhaRegraLida()
        {
            if(!this.corretorCampanha.campanhaRegraLida)
            {
                this.reiniciarDialog();
                this.dialogDinamico.persistir = true;
                this.dialogDinamico.campanhaRegra = true;
                this.dialogDinamico.mostrar = true;                    
            }else
            {
                this.verificarConquistaNotificada();
            }
        },
        listarCupons(competencia)
        {
            console.log("listarCupons", competencia);
            this.cupomCompetencia = competencia;
            this.reiniciarDialog();
            this.dialogDinamico.titulo = "<div class='dialog-titulo'>Meus cupons da sorte</div>";
            this.dialogDinamico.listaCupom=true;
            this.dialogDinamico.mostrar = true;  
        },
        marcarCupomLido()
        {
            let codigoCorretor = this.usuario.codCorretor;
            //aceite-numero-sorte/
            let url = "SouMaisPrevisul/corretor/aceite-numero-sorte/"+ codigoCorretor;                
            this.$parent.fullLoading = true;
            this.reiniciarDialog();

            Vue.prototype.$httpPortal.get(url)
            .then(res => {
                this.$parent.fullLoading = false;
                this.reiniciarDialog();
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });   
        },
        simplificarData(data, mostrarAno = true)
        {
            let _data = new Date(data);
            let _mes = ''+ (_data.getMonth() + 1);
            let _ano = ''+ (_data.getFullYear());
            let _dia = ''+ (_data.getDate()+1);

            if(_mes.length < 2)
                _mes = '0' + _mes;
            
            if(_dia.length < 2)
                _dia = '0' + _dia;
            
            if(mostrarAno)
                return `${_dia}/${_mes}/${_ano}`;
            else
                return `${_dia}/${_mes}`;
        },
        baixarRegulamento()
        {

            let _link = document.createElement('a');
            _link.href = '/upload/sou_mais/regulamento_sou_previsul_sorte_de_campeao.pdf';
            _link.download = 'regulamento_sou_previsul_sorte_de_campeao.pdf';
            _link.click();
            URL.revokeObjectURL(_link.href);            
        }      
    },
    watch: {
        "dialogDinamico.mostrar"() {
            if(this.dialogDinamico.mostrar == false)
            {
                this.reiniciarDialog();
            }
        },
    },    
    computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
    },  
    mounted()
    {
        this.carregarDados();
        console.log("mounted");
        console.log(this);
    },
    created(){
        window.baixarRegulamento = this.baixarRegulamento.bind(this);        
    }    
}
</script>
<style>

/* .sorteio-container .v-card__text {
    padding: 10px;
}  */
.sorteio-container {
    font-size:13px; 
    text-align:justify;
    line-height: 15px;
    word-break: break-word !important;
}

.sorteio-container .progress-bar-gradient {
    background: linear-gradient(90deg, #FFD600 0%, #AFFF00 100%);
}

.update-text {
    font-family: Roboto;
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.01em;
}
.sorteio-valor-info
{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 30px;
    /* or 55% */
}
.numero-sorte-info
{
    font-family: Roboto;
font-style: italic;
font-weight: normal;
font-size: 13px;
line-height: 13px;
display: flex;
align-items: center;
letter-spacing: 0.01em;
}

.historico-sorteio-nome
{
    font-family: Roboto;
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: 13px;
    letter-spacing: 0.01em;
    text-align: left;
}

</style>